import { useLang } from "@/context";
import { Reveal } from "@/components/Reveal";

export default function Credentials() {
  const { t } = useLang();

  return (
    <section data-testid="credentials-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-y-12">
          {t.credentials.map((c, i) => (
            <Reveal key={c.value} delay={i * 0.08}>
              <div
                data-testid={`credential-${i}`}
                className={`px-2 sm:px-6 py-6 text-center lg:text-left ${
                  i > 0 ? "lg:border-l lg:border-taupe/25" : ""
                }`}
              >
                <span className="font-serif text-4xl sm:text-5xl lg:text-[2.6rem] text-charcoal font-light tracking-tight block leading-tight">
                  {c.value}
                </span>
                <span className="mt-4 block text-[10px] sm:text-[11px] uppercase tracking-[0.26em] text-taupe">
                  {c.label}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
